import React from 'react';
import TransfersView from '@/components/admin/property/TransfersView';
import { useSettings } from '@/hooks/useSettings';

/**
 * Transfers Management Component
 * Wrapper for TransfersView with settings state management
 */
export const TransfersManagement = ({ API }) => {
  const { settings, updateSettings, loading } = useSettings(API);
  const [localSettings, setLocalSettings] = React.useState({
    transfer_price_one_way: settings.transfer_price_one_way || '',
    transfer_price_round_trip: settings.transfer_price_round_trip || '',
    enable_transfer_arrival: settings.enable_transfer_arrival !== undefined ? settings.enable_transfer_arrival : true,
    enable_transfer_departure: settings.enable_transfer_departure !== undefined ? settings.enable_transfer_departure : true,
    enable_transfer_round_trip: settings.enable_transfer_round_trip !== undefined ? settings.enable_transfer_round_trip : true,
    transfer_arrival_message: settings.transfer_arrival_message || ''
  });

  React.useEffect(() => {
    setLocalSettings({
      transfer_price_one_way: settings.transfer_price_one_way || '',
      transfer_price_round_trip: settings.transfer_price_round_trip || '',
      enable_transfer_arrival: settings.enable_transfer_arrival !== undefined ? settings.enable_transfer_arrival : true,
      enable_transfer_departure: settings.enable_transfer_departure !== undefined ? settings.enable_transfer_departure : true,
      enable_transfer_round_trip: settings.enable_transfer_round_trip !== undefined ? settings.enable_transfer_round_trip : true,
      transfer_arrival_message: settings.transfer_arrival_message || ''
    });
  }, [settings]);

  const handleUpdateSettings = async (e) => {
    e.preventDefault();
    // Convert string prices to numbers
    const settingsToSave = {
      ...localSettings,
      transfer_price_one_way: parseFloat(localSettings.transfer_price_one_way),
      transfer_price_round_trip: parseFloat(localSettings.transfer_price_round_trip)
    };
    await updateSettings(settingsToSave);
  };

  return (
    <TransfersView
      settings={localSettings}
      setSettings={setLocalSettings}
      settingsSaving={loading}
      handleUpdateSettings={handleUpdateSettings}
    />
  );
};
